import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import SearchBar from './searchBar';
import { textSmall } from 'styles-js/mixins/typography';

const Container = styled.div`
  display: flex;
  margin: 0 12px;
`;

const StyledSearchBar = styled(SearchBar)`
  align-items: center;
  height: 49px;
  margin-bottom: 0;

  .search-bar__container {
    height: 36px;
    margin-bottom: 0;
  }

  .search-bar__input {
    font-size: ${({theme}) => theme.fontSizeXs};
  }

  .search-bar__icon {
    width: 40px;
    font-size: 18px;
  }

  .react-autosuggest__suggestions-container {
    margin-top: -5px;
  }
`;

const CancelButton = styled.button`
  ${textSmall};
  margin-left: 10px;
  border: 0;
  padding: 0;
  -webkit-appearance: none;
  background-color: transparent;
  cursor: pointer;
`;

const MobileSearchInput = ({ onCancel }) => (
  <Container>
    <StyledSearchBar customId="-mobile" onSearch={onCancel} />
    <CancelButton onClick={onCancel}>{i18n.t('Cancel')}</CancelButton>
  </Container>
);

MobileSearchInput.propTypes = {
  onCancel: PropTypes.func,
};

MobileSearchInput.defaultProps = {
  onCancel: () => {},
};

export default MobileSearchInput;
